import styled from '@emotion/styled'
import { useCallback, useState } from 'react'

import { Button } from '@/components/Button'

import { CONFIG } from '@/styles/emotion.config'

import PanelItem, { type PanelItemProps } from './Paneltem'

export interface ListPanelProps {
  items: PanelItemProps[]
}

const ListPanelStyles = styled.div<{ items: number }>((props) => ({
  '--columns': 1,
  display: 'grid',
  gap: '1rem',
  height: 'auto',
  marginBottom: 'var(--space-4)',
  maxHeight: `calc((${props.items} / var(--columns)) * 32rem)`,
  gridTemplateColumns: 'repeat(var(--columns), minmax(0, 1fr))',
  transition: 'max-height var(--transitions-default)',

  [CONFIG.media.md]: {
    '--columns': 2,
  },

  [CONFIG.media.lg]: {
    '--columns': 3,
  },
}))

const itemsPerRow = 3
const initialAmountOfItemsToShow = 6

const ListPanel = ({ items }: ListPanelProps) => {
  const [showItems, setShowItems] = useState(initialAmountOfItemsToShow)
  const itemsCount = items.length

  const handleClick = useCallback(() => {
    if (showItems >= itemsCount) {
      return
    }

    setShowItems((state) => state + itemsPerRow)
  }, [itemsCount, showItems])

  if (!items) {
    return null
  }

  return (
    <>
      <ListPanelStyles items={showItems}>
        {items.slice(0, showItems).map((item, index) => (
          <PanelItem
            key={`lpanel_item_${index}`}
            {...item}
            layout="fixed"
            width={294}
            height={200}
          />
        ))}
      </ListPanelStyles>

      {showItems < itemsCount && (
        <div className="et-ta-center">
          <Button modifier="outline" size="lg" onClick={handleClick}>
            Carregar mais
          </Button>
        </div>
      )}
    </>
  )
}

export default ListPanel
